export default {
    xboot: 'CRCF-RedCode',
    usernameLogin: 'Username Sign in',
    mobileLogin: 'Phone',
    autoLogin: 'Remember me',
    forgetPass: 'Forget password',
    otherLogin: 'Sign in with',
    regist: 'Register',
    register: "Register",
    registering: "Registering...",
    registerNow: "No account yet？Register now",
    loginNow: "Sign in with an account",
    login: 'Sign in',
    logining: 'Signing in...',
    home: 'Home',
    searchMenu: 'Search Menu...',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    Notifications: 'Notifications',
    showMore: 'View More',
    markAll: 'Mark all as read',
    refresh: 'Refresh',
    noNewMes: 'There are no new unread messages',
    userCenter: 'Account Center',
    changePass: 'Change Password',
    logout: 'Sign out',
    closeAll: 'Close All',
    closeOthers: 'Close Others',
    docs: 'Docs',
    fullVersion: 'Go-DP',
    rights: 'All Rights Reserved',
    sso: "Go-DP Authentication Platform",
    authorize: "Authorize",
    authorizeAndSignin: "Authorize and Sign in",
    authorizing: "Authorizing...",
    wants: "wants to access your account",
    wants2: "",
    authAquire: "Public data only",
    aquireInfo: "Limited access to your public data",
    afterAuth: "Authorizing will redirect to",
    relateTitle: "Bind Go-DP's Account",
    relate: "Bind",
    relating: "Binding...",
    themeTitle: "Theme Style Setting",
    wholeSetting: "Whole Style Preset",
    lightblue: "Light Blue Style",
    topNav: "Menu Top Fixed Style",
    darkblue: "Dark Blue Style",
    darkMode: "Dark Mode",
    dark: "Dark Style",
    middle: "Neutral Style",
    white: "Light White Style",
    sideMenu: "Side Menu Style",
    navMenu: "Navigation Style",
    navMode: "Navigation Mode",
    rightTop: "Right Top",
    topFix: "Top Fixed",
    navType: "Nav Show Type",
    horizontal: "Horizontal",
    singleDrop: "Single Dropdown",
    iconBreadcrumb: "Icon+Breadcrumb",
    showIcon: "Show Icon",
    dropMenu: "DropMenu Type",
    appStyle: "App Icon Style",
    listStyle: "List Mode",
    contentArea: "Content Area",
    enableTags: "Enable Multi-Tags",
    showLogo: "Show Logo",
    showFold: "Show Fold Menu Icon",
    showSearchMenu: "Show Search Menu",
    showFooter: "Show Footer",
    sideMenuWidth: "Side Menu Width",
    otherSetting: "Other Setting",
    weakMode: "Weak Mode",
    themeInfo: "This is mainly for previewing the layout. It is recommended that only some functions are opened or closed for users in the production environment"
};
